export const EMAIL_PATTERN =/^[a-z0-9._-]+@([a-z0-9-]+\.)+[a-zA-Z]{2,6}$/i;

export function isValidEmail(email: string) : boolean {
    return EMAIL_PATTERN.test(email);
}

export function isEmptyOrValidEmail(email?: string) : boolean {
    return email ? EMAIL_PATTERN.test(email) : true;
}
